import zh from './zh/index'
import en from './en/index'

export default {
  default: 'zh',
  zh: zh,
  en: en
}



// WEBPACK FOOTER //
// ./src/lang/language.js